/* eslint-disable no-param-reassign */
import axios from 'axios';
import { getAccessToken } from './auth/authProvider';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_UNI_URL,
});

client.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;
